import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

// note: all of these are imported by sub-components in this directory

///////////////////////
// CORE STYLES for ALL
//////////////////////
export const baseBody: CSSProperties = {
  padding: "15px 12px",
  backgroundColor: "rgba(250,250,250,1)",
};

///////////////////////
// LITTLE META LINE
///////////////////////
export const metaInfo: CSSProperties = {
  color: greys.slate,
  fontSize: 12,
  marginBottom: 10,
};

///////////////////////
// FOR EVENT INFO
//////////////////////
export const eventDateRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const eventDateIcon = {
  htmlColor: greys.lightishGrey,
  style: {
    flexShrink: 0,
    height: 16,
    width: 16,
  } as CSSProperties,
};

export const eventDate: CSSProperties = {
  color: greys.darkestGrey,
  fontSize: 12,
  marginLeft: 10,
  padding: "5px 0",
};
